export default "__VITE_ASSET__90c98b8e__"